import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../../workflows/ICardComponent';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { ControlContainer, NgForm } from '@angular/forms';
import { SecurityService } from '../../../_infrastructure/Security/SecurityService';


@Component({
  selector: 'service-identification-pre-stage',
  templateUrl: './service-identification-pre-stage.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class ServiceIdentificationPreStageComponent implements OnInit, OnDestroy{
  @Input() model: models.SenderIdentificationVM = {} as models.SenderIdentificationVM;

  public code: string;

  //@CommonData(DomainCodes.domains)
  //public domains: models.DimensionVM[];
  //@CommonData(DomainCodes.country)
  //public countries: models.DimensionVM[];

  constructor(private securityService: SecurityService) {
    this.code = this.securityService.userDetails.service;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
